export var HEADER_CHANNELS = ['row', 'column'];
export var HEADER_TYPES = ['header', 'footer'];